'use client';
import { usePathname } from 'next/navigation';

import Script from 'next/script';

import { Locales } from '@monoimin/sb-types';
import { getLocalePrefix } from '@monoimin/intl';
import { adjustPathname, getUrlOrigin } from '@monoimin/utils/helpers';
import { replaceYearString } from '@monoimin/atoms/utils/replaceYearString';

export function WebPageSchema({
  speakable,
  miniSiteSlug,
  locale,
  ...rest
}: {
  speakable: string[];
  locale: Locales;
  miniSiteSlug?: MiniSlug;
  [k: string]: string | object | undefined;
}) {
  const pathname = usePathname();
  const localePrefix = getLocalePrefix(locale);
  const pathnameWithoutPrefix = String(pathname).replace(localePrefix, '');
  const speakableWithYear = speakable.map((el) => replaceYearString(el));
  const originURL = getUrlOrigin(locale, miniSiteSlug);
  const schemaData = {
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    speakable: speakableWithYear,
    url: adjustPathname(originURL + pathnameWithoutPrefix),
    '@id': adjustPathname(originURL + pathnameWithoutPrefix) + '#ContentSchema',
    ...rest,
  };
  return (
    <Script id='web-page-jsonld' type='application/ld+json'>
      {JSON.stringify(schemaData)}
    </Script>
  );
}

export default WebPageSchema;
